import React, { Component } from 'react'
import TextInput from './inputs/TextInput'
import HttpServices from '../utils/Http.services'
import { checkTranslation, translate } from '../utils/useful'
import ButtonAnimated from './buttons/ButtonAnimated'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';

class AddViewList extends Component {

    state = {
        views: [
            { name: '{{lang}}Table', key: 'table', },
            // { name: '{{lang}}List', key: 'list', },
            { name: '{{lang}}Card', key: 'card', },
            { name: '{{lang}}Matrix', key: 'matrix', },
            { name: '{{lang}}Kanban', key: 'kanban', },
            { name: '{{lang}}Gantt', key: 'gantt', },
            { name: '{{lang}}Calendar', key: 'calendar', },
            { name: '{{lang}}Form', key: 'form', },
            // { name: '{{lang}}Report', key: 'report', },
        ],
        currentView: null,
        viewName: '',
        isLoading: false,
        viewsList: []
        // nameCheck : true,

    }

    componentDidMount() {
        let { views, viewsList } = this.state
        let headers = this.props.headers
        let matrix = []
        let calendar = []
        viewsList.push({ name: '{{lang}}Table', key: 'table', })
        viewsList.push({ name: '{{lang}}Card', key: 'card', })
        // viewsList.push({ name: '{{lang}}Calendar', key: 'calendar', })
        // viewsList.push({ name: '{{lang}}Matrix', key: 'matrix', })
        // viewsList.push({ name: '{{lang}}Boards', key: 'kanban', })
        // let matrix = headers.find((header) => header.type == )
        headers.forEach(header => {
            if (header.type == 'LocalSelectInput') {
                matrix.push(header)
            }
            if (header.type == 'SelectInput') {
                matrix.push(header)
            }
            if (header.type == 'MultiSelectInput') {
                matrix.push(header)
            }
            if (header.type == 'AdvancedSelectInput') {
                matrix.push(header)
            }
            if (header.type == 'GlobalUserInput') {
                matrix.push(header)
            }
            if (header.type == 'DateInput') {
                matrix.push(header)
                calendar.push(header)
            }
            if (header.type == 'TimeInput') {
                matrix.push(header)
            }
            if (header.type == 'DateTimeInput') {
                matrix.push(header)
                calendar.push(header)
            }
        });
        if (matrix.length >= 2) {
            viewsList.push({ name: '{{lang}}Matrix', key: 'matrix', })
        }

        if (matrix.length >= 1) {
            viewsList.push({ name: '{{lang}}Kanban', key: 'kanban', })
        }

        // viewsList.push({ name: '{{lang}}Gantt', key: 'gantt', })
        if (calendar.length > 0) {
            viewsList.push({ name: '{{lang}}Calendar', key: 'calendar', })
        }
        viewsList.push({ name: '{{lang}}Form', key: 'form', })
        this.setState({ viewsList })
    }

    creatAddView = (type, name) => {
        this.props.setAddViewLoading(true)
        let data = {
            type,
            name
        }
        if (this.state.currentView == null) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.TypeRequired', description: translate("") })
            this.props.setAddViewLoading(false)
        }
        if (name.trim() != '') {
            this.props.functionsHandler(null, 'creatAddView', data)
            // this.setState({isLoading:false})
        }
        else {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.NameRequired', description: translate("") })
            this.props.setAddViewLoading(false)
        }
        // else {
        //     this.setState({ nameCheck: true })
        // }
        // return

    }

    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }
    render() {
        return (
            <div className='  h-100 white-bg' style={{ overflow: 'hidden' }}>
                <div className='p-3 position-sticky top-0' style={{ background: this.props.background ?? 'linear-gradient(90deg, #5856D6, #7D7AFF)', zIndex: 2, height: '50px' }}>
                    <p className='white'>{translate('Add View')}</p>
                </div>

                <div className='scroll-no-scrollbar h-100 pb-5' style={{ zIndex: 1, backgroundColor: "#fff", }}>
                    <div className='p-2' style={{ backgroundColor: '#F2F2F7' }}>
                        <p className='font-size-12 weight-500 main-c5 px-2'>{translate('Choose the view style')}</p>
                        <p className='font-size-10 main-c7 px-2 pb-2'>{translate('The View Will be shows to you by this name you given')}.</p>
                    </div>
                    <div className='p-2'>
                        {this.state.viewsList.map((prop, index) => {
                            return (
                                <div className='bb-gray py-1'>
                                    <button className='flexc w-100 hover-gray2 p-2 br-10' style={{ backgroundColor: (this.state.currentView?.key == prop.key ? '#F2F2F7' : '') }} onClick={() => this.setState({ currentView: prop })}>
                                        <div className='flexcb w-100'>
                                            <div className='flexc'>
                                                <img src={'/assets/icons/applets/database/' + prop.key + '.svg'} width={22} />
                                                <p className='font-size-12 mld-3 main-c6'>{checkTranslation(prop.name)}</p>
                                            </div>
                                            {this.state.currentView?.key == prop.key &&
                                                <div className='flexcc'>
                                                    <img width={20} src='/assets/icons/check-purple.svg' />
                                                </div>
                                            }
                                        </div>
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                    <div className='messenger-input w-100 pb-4 p-2' style={{ backgroundColor: '#F2F2F7' }}>
                        <p className='font-size-12 weight-500 main-c5 px-2'>{translate('Choose the view name')}.</p>
                        <p className='font-size-10 main-c7 px-2 pb-2'>{translate('The View Will be shows to you by this name you given')}.</p>
                        <div className='flexcc purple-box-border-h px-2 py-2 br-10 mb-5'>
                            <TextInput data={this.state.viewName} changeValue={this.changeValue} header={{ key: 'viewName', information: { rows: 1, placeholder: translate('View Name') } }} />
                        </div>
                    </div>
                </div>
                <div className='flexc blur-bg py-2 px-2 w-100' style={{ position: "sticky", bottom: 0, zIndex: 10 }}>
                    <div className="flexc mrd-2 w-50">
                        <ButtonAnimated
                            iconwidth='24px'
                            onClick={() => { this.props.closeAddView() }}
                            title={translate('Discard')}
                            textColor={'#a3a2b0'}
                            bg={'#eee'}
                            width={'100%'}
                        />
                    </div>
                    <div className="flexc mld-2 w-50">
                        <ButtonAnimated
                            iconwidth='24px'
                            onClick={this.props.isLoadingView ? () => { } : () => { this.creatAddView(this.state.currentView?.key, this.state.viewName) }}
                            title={translate('Save')}
                            icon='/assets/icons/plus-white.svg'
                            textColor={'#fff'}
                            isLoading={this.props.isLoadingView}
                            bg={this.props.background ?? ' linear-gradient(90deg, #5856D6, #7D7AFF)'}
                            width={'100%'}
                        />
                    </div>


                    {/* <button className='gray-btn w-100 mx-2 py-2 br-5' onClick={() => this.props.changeStage('info')}>
                        <p className='main-c5'>{translate('Discard')}</p>
                    </button>
                    <button className='purple-btn w-100 mx-2 py-2 br-5' onClick={() => this.creatAddView(this.state.currentView.key, this.state.viewName)}>
                        <p>{translate('Save')}</p>
                    </button> */}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddViewList);